
import React from 'react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu, BarChart3, FileText, History, Mic } from 'lucide-react';
import { CallAnalytics } from '@/components/dialer/CallAnalytics';
import { CallNotes } from '@/components/dialer/CallNotes';
import { CallHistory } from '@/components/dialer/CallHistory';
import { CallRecording } from '@/components/dialer/CallRecording';

interface DialerSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  isMobileMenuOpen: boolean;
  onMobileMenuChange: (open: boolean) => void;
}

export const DialerSidebar = ({ 
  activeTab, 
  onTabChange, 
  isMobileMenuOpen, 
  onMobileMenuChange 
}: DialerSidebarProps) => {
  const SidebarContent = () => (
    <Tabs value={activeTab} onValueChange={onTabChange} className="h-full flex flex-col w-full">
      <TabsList className="grid w-full grid-cols-4 rounded-none border-b">
        <TabsTrigger value="analytics" className="flex items-center gap-1 text-xs">
          <BarChart3 className="h-3 w-3" />
          Stats
        </TabsTrigger>
        <TabsTrigger value="notes" className="flex items-center gap-1 text-xs">
          <FileText className="h-3 w-3" />
          Notes
        </TabsTrigger>
        <TabsTrigger value="history" className="flex items-center gap-1 text-xs">
          <History className="h-3 w-3" />
          History
        </TabsTrigger>
        <TabsTrigger value="recording" className="flex items-center gap-1 text-xs">
          <Mic className="h-3 w-3" />
          Record
        </TabsTrigger>
      </TabsList>
      
      <div className="flex-1 overflow-hidden">
        <TabsContent value="analytics" className="h-full m-0">
          <CallAnalytics />
        </TabsContent>
        
        <TabsContent value="notes" className="h-full m-0">
          <CallNotes />
        </TabsContent>
        
        <TabsContent value="history" className="h-full m-0">
          <CallHistory />
        </TabsContent>
        
        <TabsContent value="recording" className="h-full m-0">
          <div className="p-4">
            <CallRecording />
          </div>
        </TabsContent>
      </div>
    </Tabs>
  );

  return (
    <>
      {/* Mobile menu toggle */}
      <div className="lg:hidden absolute top-4 right-4 z-10">
        <Sheet open={isMobileMenuOpen} onOpenChange={onMobileMenuChange}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="sm">
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-80">
            <SidebarContent />
          </SheetContent>
        </Sheet>
      </div>

      {/* Desktop sidebar */}
      <div className="hidden lg:flex w-80 border-l bg-background">
        <SidebarContent />
      </div>
    </>
  );
};
